import React from 'react';
import I18n from 'i18n-js';
import { func, shape } from 'prop-types';
import { Modal, Icon } from 'grab-ui';
import { INVALID_TOKEN_MODAL } from 'constants/app-constants';

import css from './invalid-token-modal.less';

const InvalidTokenModal = props => {
  const { invalidToken: { yes, anyoneLoggedIn }, onOk } = props;

  return (
    <Modal
      visible={yes}
      onOk={onOk}
      okText={I18n.t(INVALID_TOKEN_MODAL.OK_TEXT)}
      width={540}
      closable={false}
      maskClosable={false}
      keyboard={false}
      className={css.modal}
    >
      <div className={css.content}>
        <Icon type="exclamation-circle" />
        <div className={css.message}>
          <h4>
            {I18n.t(
              anyoneLoggedIn
                ? INVALID_TOKEN_MODAL.ANYONE_LOGGEDIN_TITLE
                : INVALID_TOKEN_MODAL.SESSION_TIMEOUT_TITLE,
            )}
          </h4>
          <h5>
            {I18n.t(
              anyoneLoggedIn
                ? INVALID_TOKEN_MODAL.ANYONE_LOGGEDIN_CONTENT
                : INVALID_TOKEN_MODAL.SESSION_TIMEOUT_CONTENT,
            )}
          </h5>
        </div>
      </div>
    </Modal>
  );
};

InvalidTokenModal.propTypes = {
  invalidToken: shape({}).isRequired,
  onOk: func.isRequired,
};

export default InvalidTokenModal;
